import React from 'react';
import { Loader2 } from 'lucide-react';

const Loader = () => {
  return (
    <div className="flex items-center justify-center">
      <Loader2 className="h-5 w-5 animate-spin text-blue-500" />
    </div>
  );
};

export default Loader;
